import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2defd4a0&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defd4a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2defd4a0')) {
      api.createRecord('2defd4a0', component.options)
    } else {
      api.reload('2defd4a0', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2defd4a0&scoped=true", function () {
      api.rerender('2defd4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/opcManagement/opcInfoManagement/list.vue"
export default component.exports